import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild } from "@angular/core";
import { RepositoryService } from "../../linq-utils/repository.service";
import { MaterialModule } from "../../material/material.module";

// plays a help or tutorial video from the server, with the browser's own controls and a way to start again
@Component({
    selector: 'app-video',
    templateUrl: 'video.html',
    imports: [MaterialModule],
    standalone: true,
    styleUrls: ['video.css']
})
export class VideoComponent implements AfterViewInit, OnChanges, OnDestroy {
    @Input() startPlaying:boolean = false
    @Input() videoUrl:string
    @Input() showRestart = true          // the button to play it again; the player's own controls do that too

    fullVideoUrl:string
    video:HTMLVideoElement
    failed = false          // the video couldn't be loaded
    loading = false         // waiting for enough of the video to show
    playing = false         // kept from the video's own events, so it matches whichever control was used
    private playWhenLoaded = false
    @ViewChild('videoPlayer') videoPlayer:ElementRef

    constructor(private repoService:RepositoryService) {

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['videoUrl'] && this.video) this.getVideoUrl()
    }

    ngAfterViewInit(): void {
        if (this.videoPlayer) {
            this.video = this.videoPlayer.nativeElement
            if (this.videoUrl) setTimeout(() => this.getVideoUrl(), 0)
        }
    }

    ngOnDestroy(): void {
        this.video?.pause()
    }

    getVideoUrl() {
        this.failed = false
        this.playing = false
        this.fullVideoUrl = this.videoUrl && this.repoService.createCompleteRoute(this.videoUrl)
        this.loading = !!this.fullVideoUrl
        // a video set to start playing does so once it has loaded: asked before, the play is lost to the load
        this.playWhenLoaded = this.startPlaying
        // the new address reaches the page's source once Angular has updated it, so the video loads after that
        setTimeout(() => this.video?.load(), 0)
    }

    onError() {
        this.loading = false
        this.playWhenLoaded = false
        this.failed = !!this.videoUrl
    }

    onLoaded() {
        this.loading = false
        if (this.playWhenLoaded) {
            this.playWhenLoaded = false
            this.play()
        }
    }

    onPlayingChange(playing:boolean) {
        this.playing = playing
    }

    isPlaying() {
        return this.playing
    }

    togglePlay() {
        if (this.video?.paused) this.play()
        else this.pause()
    }

    // browsers can refuse to start a video, such as before the user has clicked anything; the play button still works then
    play() {
        this.video?.play()?.catch(() => undefined)
    }

    pause() {
        this.video?.pause()
    }

    // back to the beginning; a video that failed is fetched again
    restart() {
        if (!this.video) return
        if (this.failed) {
            this.getVideoUrl()
        }else {
            this.video.currentTime = 0
        }
        this.play()
    }
}
